module.exports = __webpack_public_path__ + "res/media/profile_img_male01.32be8bcd.png";